//@ts-ignore
import PersianDate from "persian-date";
import { _ } from ".";

export namespace DateService {

    const oneSecond = 1 * 1000;
    const oneMinute = 60 * oneSecond;
    const oneHour = 60 * oneMinute;
    const oneDay = 24 * oneHour;

    const todayStart = () => {
        return new Date().setHours(0, 0, 0, 0);
    };

    export const isToday = (dateString: string) => {
        return new Date(dateString).setHours(0, 0, 0, 0) === todayStart();
    };

    export const isTomorrow = (dateString: string) => {
        return new Date(dateString).setHours(0, 0, 0, 0) - todayStart() === oneDay;
    };

    export const persianDate = (value: string | Date, format: string = "YYYY MM DD") => {
        if (!value) return "";

        let dateValue = new Date(value);
        return new PersianDate(dateValue).format(format);
    };

    export const getPersianDate = (value: string | Date) => {
        if (!value) return undefined;
        let dateValue = new Date(value);
        return new PersianDate(dateValue);
    };

    export const gregorianDate = (year: number, month: number, date: number) => {
        const result: Date = new PersianDate([year, month, date, 0, 0, 0, 0]).toDate();
        const timeOffset = result.getTimezoneOffset();
        result.setMinutes(result.getMinutes() - timeOffset);
        return result;
    };

    export const getRemainingTime = (remainingSecond: number) => {
        let remaining = remainingSecond * 1000;

        const days = Math.floor(remaining / oneDay);
        const daysVisible = days > 0;
        remaining = remaining % oneDay;


        const hours = Math.floor(remaining / oneHour);
        const hoursVisible = daysVisible || hours > 0;
        remaining = remaining % oneHour;


        const minutes = Math.floor(remaining / oneMinute);
        remaining = remaining % oneMinute;


        const seconds = Math.floor(remaining / oneSecond);

        return [
            { title: _("day"), value: days, base: 1, visible: daysVisible },
            { title: _("hour"), value: hours, base: 24, visible: hoursVisible },
            { title: _("minute"), value: minutes, base: 60, visible: true },
            { title: _("second"), value: seconds, base: 60, visible: true },
        ];

    };

    export const daysTitle: string[] = PersianDate.rangeName().weekdaysMin;

    export const daysInMonth = (year: number, month: number): number => {
        if (month > 0 && month < 7) return 31;

        if (month > 6 && month < 12) return 30;

        return new PersianDate([year]).isLeapYear() ? 30 : 29;
    };

    export const getTvDates = () => {

        const countOfWeek = 5;
        const daysOfWeek = 7;
        const today = new PersianDate();

        const todayInWeek = today.day();
        const todayMonth = today.month();
        const todayDate = today.date();
        const todayYear = today.year();

        const monthDays = daysInMonth(todayYear, todayMonth);

        const lastMonth = today.date(1).month(today.month() - 1);
        const lastMonthDays = daysInMonth(lastMonth.year(), lastMonth.month());

        const result = [];

        for (let w = 0; w < countOfWeek; w++) {
            const days = [];
            for (let d = 0; d < daysOfWeek; d++) {

                let year = todayYear;
                let month = todayMonth;

                const diff = (countOfWeek - w - 1) * daysOfWeek + todayInWeek - d - 1;
                let day = todayDate - diff;

                if (day <= 0) {
                    day += lastMonthDays;
                    month--;
                    if (month < 1) {
                        month = 12;
                        year--;
                    }
                }
                if (day > monthDays) {
                    day -= monthDays;
                    month++;
                    if (month > 12) {
                        month = 1;
                        year++;
                    }
                }

                days.push({
                    year,
                    month,
                    day,
                    title: day,
                    active: diff >= 0 && diff < 14,
                    today: diff === 0
                });

            }
            result.push(days);
        }
        return result;

    };
}